module.exports = __webpack_public_path__ + "img/audience_ye3.3096ef1b.jpg";